import React, { useState, useEffect } from 'react';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import localization from 'assets/localization/localization';
import { DatePickerInput } from 'rc-datepicker';
import { FormGroup } from 'react-bootstrap';
// import Regex from 'services/utils/regex/Regex';
// import ConstantInput from 'components/sales/Input/constantInput/constantInput';

const InvoiceFilterForm = ({ applyFilter, status = [], invoiceFilters }) => {
  const [filterFieldsData, setFilterFieldsData] = useState({});
  const [isFocus, setIsFocus] = useState(false);

  useEffect(() => {
    setFilterFieldsData(invoiceFilters);
    if (invoiceFilters?.date) {
      setIsFocus(true);
    }
  }, [invoiceFilters]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
        filterFieldsData &&
          localStorage.setItem('applyFilter', JSON.stringify(filterFieldsData));
      }}
    >
      {/* <ConstantInput
        label={localization.siteNumber}
        value={filterFieldsData.site_no}
        regex={Regex.number.test(filterFieldsData.site_no)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, site_no: val })
        }
      /> */}
      <FormGroup
        className={`date custom_date_picker ${isFocus ? 'active-date' : ''}`}
      >
        <DatePickerInput
          onChange={(jsdate, dateString) =>
            setFilterFieldsData({
              ...filterFieldsData,
              date: dateString,
            })
          }
          value={filterFieldsData?.date}
          autoClose
          onShow={() => setIsFocus(true)}
          onHide={() => !filterFieldsData.date && setIsFocus(true)}
          closeOnClickOutside
          showOnInputClick
          locale="en"
          className="my-custom-datepicker-component"
          displayFormat="DD-MM-YYYY"
          returnFormat="DD-MM-YYYY"
          maxDate={new Date()}
        />
        <label>{localization.invoiceDate}</label>
      </FormGroup>

      <DropDownInput
        disabled={status.length === 0}
        label={localization.status}
        data={status}
        getValueById={filterFieldsData?.status}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, status: val.id })
        }
      />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            localStorage.setItem('applyFilter', JSON.stringify({}));
            applyFilter({});
            localStorage.setItem('statusFilter', JSON.stringify({}));
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default InvoiceFilterForm;
